var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"card",staticClass:"private-card-card",style:({
        transform: `perspective(1000px) rotate3d(1, 0, 0, ${15*(_vm.cardPerspective.y)}deg) rotate3d(0, 1, 0, ${15*_vm.cardPerspective.x}deg)`,
    })})
}
var staticRenderFns = []

export { render, staticRenderFns }